import React from 'react'
import PropTypes from 'prop-types'
import ContextConsumer from './Context'

// Add some padding bottom to enable users can scroll to the
// bottom of the page when quickbet, snackbar etc are open

const ScrollAllowance = ({ children }) => (
  <ContextConsumer>
    {({ data }) => (
      <div style={{ paddingBottom: `${data.scrollAllowance}px` }}>
        {children}
      </div>
    )}
  </ContextConsumer>
)

ScrollAllowance.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ScrollAllowance
